import React from 'react';
import { FaFileAlt, FaVideo, FaDownload, FaMobileAlt, FaAward } from 'react-icons/fa';

const CourseIncludes = ({data}) => {
  return (
    <div className="mt-1 p-6 bg-gray-90  border">
      <h2 className="text-xl font-bold text-gray-900 mb-3">Este curso incluye:</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700">
        <div className="flex items-center gap-2">
          <FaVideo className="text-gray-900" /> {data.videos.length} Videos disponibles 24/7 
        </div>
        <div className="flex items-center gap-2">
          <FaFileAlt className="text-gray-900" /> {data.documents.length} artículos
        </div>
        <div className="flex items-center gap-2">
          <FaDownload className="text-gray-900" /> {data.documents.length} recursos descargables
        </div>
        <div className="flex items-center gap-2">
          <FaMobileAlt className="text-gray-900" /> Acceso en dispositivos móviles y TV
        </div>
        <div className="flex items-center gap-2">
          <FaAward className="text-gray-900" /> Certificado de finalización
        </div>
      </div>
    </div>
  );
};

export default CourseIncludes;
